import {isRejectedWithValue} from '@reduxjs/toolkit'

import {bookApi} from '@vio/core/src/booking/services/bookApi'

import {logEvent} from '../analytics/utils/logEvent'
import {MiddlewareType} from '../middlewareList'

const getPathname = () => {
  // jsdom issue breaking tests only - https://github.com/jsdom/jsdom/issues/2121
  try {
    return typeof window !== 'undefined' ? window.location.pathname : ''
  } catch {
    return ''
  }
}

const middleware: MiddlewareType = () => next => async action => {
  const metadata = {
    params: action?.meta?.arg?.originalArgs || {},
    space: getPathname()
  }

  if (bookApi.endpoints.getBookings.matchPending(action)) {
    logEvent(
      'Services.BoVio.Bookings.Start',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (bookApi.endpoints.getBookings.matchFulfilled(action)) {
    logEvent(
      'Services.BoVio.Bookings.Done',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (
    bookApi.endpoints.getBookings.matchRejected(action) &&
    isRejectedWithValue(action)
  ) {
    logEvent(
      'Services.BoVio.Bookings.Error',
      metadata,
      'error',
      'BookingManagement'
    )
  }

  if (bookApi.endpoints.getInvoice.matchPending(action)) {
    logEvent(
      'Services.BoVio.Invoice.Start',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (bookApi.endpoints.getInvoice.matchFulfilled(action)) {
    logEvent(
      'Services.BoVio.Invoice.Done',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (
    bookApi.endpoints.getInvoice.matchRejected(action) &&
    isRejectedWithValue(action)
  ) {
    logEvent(
      'Services.BoVio.Invoice.Error',
      metadata,
      'error',
      'BookingManagement'
    )
  }

  if (
    bookApi.endpoints.getSupportToken.matchRejected(action) &&
    isRejectedWithValue(action)
  ) {
    logEvent(
      'Services.BoVio.SupportToken.Error',
      {
        bookingId: action.meta?.arg?.originalArgs?.bookingId,
        status: action.payload?.status,
        space: getPathname()
      },
      'error',
      'BookingManagement'
    )
  }

  return next(action)
}

export default middleware
